export default __webpack_public_path__ + "static/media/definition.5c6737e3.svg";